<template>
    <main>
        <header class="banner home">
            <div class="container">
                <h1>{{ data.banner.title }}</h1>
                <h4>{{ data.banner.description }}</h4>
            </div>
            <div class="clip-path-one green70">
                <span class="arrow-header"></span>
            </div>
        </header>

        <section class="expertise-areas">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 offset-md-4 text-center">
                        <h3>{{ data.solutions.title }}</h3>
                        <!-- <h5>{{ data.solutions.description }}</h5> -->
                    </div>
                </div>
                <div class="row justify-content-md-center expertise-list">
                    <div class="col-md-4" v-for="expertise of data.solutions.cards">
                        <div class="card" :class="expertise.class">
                            <div class="card-heading">
                                <h3>{{ expertise.title }}</h3>
                            </div>
                            <div class="card-content">
                                <p>{{ expertise.text }} </p>
                            </div>
                            <div class="card-bottom" :style="{ 'background-image': 'url(' + expertise.imageUrl + ')' }">
                                <div class="clip-path-card green70">
        
                                
                                    <router-link :to="expertise.link" v-if="expertise.link === '/solucoes/educacionais'" tag="a">More details +</router-link>
                                    <a v-if="expertise.link === 'epcircle'" :href=" expertise.linkout" tag="a" ></i>Go to Epcircle site +</a>
                                    <a v-if="expertise.link === 'bludocc'" :href=" expertise.linkout" tag="a" ></i>Go to Bludocc site +</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            


            </div>
        </section>

        <call-action :data="data.callToAction"></call-action>

        <blog-carousel></blog-carousel>

        <section class="partners">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h3>Partners and Clients</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 offset-md-1">
                        <div id="carouselPartners" class="carousel slide" data-ride="carousel" data-interval="false">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class="row">
                                        <div class="col-4 col-md-3" v-for="partner of data.partners.slice(0,12)">
                                            <div class="card">
                                                <img :src="partner.imageUrl" class="img-fluid">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-4 col-md-3" v-for="partner of data.partners.slice(12,24)">
                                            <div class="card">
                                                <img :src="partner.imageUrl" class="img-fluid">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </section>

    
        <section class="contact">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 offset-md-1 text-center" style="margin-bottom: 50px;">
                        <h3>{{ data.contact.title }}</h3>
                        <h4>{{ data.contact.description }}</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 offset-md-1">
                        <div class="row">
                            <div class="col-md-5">
                                <form v-on:submit.prevent="onSubmit" id="form">
                                    <div class="form-group">
                                        <input type="text" class="form-control" placeholder="Name*:" id="name">
                                    </div>
                                    <div class="form-group">
                                        <input type="email" class="form-control" placeholder="E-mail*:" id="email">
                                    </div>
                                    <div class="form-group">
                                        <input type="phone" class="form-control" placeholder="Phone:" id="phone">
                                    </div>
                                    <div class="form-group">
                                        <input type="text" class="form-control" placeholder="Subject*:" id="subject">
                                    </div>
                                    <div class="form-group">
                                        <textarea class="form-control" placeholder="Message*:" rows="5" id="message"></textarea>
                                    </div>
                                    <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="data.contact.msgForm === 'success'">
                                        <strong>Success!</strong> Your message has been sent, please wait for our return
                                    </div>
                                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="data.contact.msgForm === 'error'">
                                        <strong>Ops...</strong> Unable to send message now, please try again.
                                    </div>
                                    <button type="submit" class="btn btn-viitra-dark float-right">Send</button>
                                </form>
                            </div>
                            <div class="col-md-6 offset-md-1">
                                <div class="map">
                                    <iframe :src=info.address.mapUrl></iframe>
                                    <div class="map-address-info">
                                        {{ info.address.street }}<br>{{ info.address.city }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    export default {
        methods: {
            onSubmit() {
                this.data.contact.msgForm = undefined;
                const body =  {
                    name: $('#name').val(),
                    subject: $('#subject').val(),
                    email: $('#email').val(),
                    phone: $('#phone').val(),
                    message: $('#message').val()
                }
                this.$http.post('/static/mail/contact_me.php', body).then(function (res) {
                    this.data.contact.msgForm = 'success'
                    $('#form').reset();
                }, function(err) { this.data.contact.msgForm = 'error' })
            }
        },
        props: ['info'],
        data() {
            return {
                data: {
                    banner: {
                        title: 'Innovative Solutions',
                        description: 'For high impact business'
                    },
                    solutions: {
                        title: 'Specialty Areas',
                        description: '',
                        cards: [
                            {
                                 title: 'Educational Solutions',
                                 text: 'Our learning solutions are optimized for your business strategic goals. In addition to provide platforms and mobile solutions, we also produce a variety of types of media such as eBooks,  videos, infographics, questions, etc.; all of them highly adapted to context and aim to transform the learning processes into something more light and dynamic.',
                                 imageUrl: 'static/images/headers/solutions-edu.jpg',
                                 link: '/solucoes/educacionais',
                                 class: 'large-size',
                                 linkout: '', 
                            },
                            {
                                 title: 'Energy Labelling',
                                 text: 'Our high-resolution EPC toolbox is based on a user-friendly and airtight mobile app for in-situ data collection, combined with a state-of-the-art energy calculation engine deployed in the cloud, that utilizes high-precision data and images from satellites to increase the accuracy of EPC.',
                                 imageUrl: 'static/images/headers/epcircle.jpg',
                                 link: 'epcircle',
                                 class: 'large-size',
                                 linkout: 'http://epcircleenergy.com/', 
                            },
                            {
                                 title: 'Bludocc',
                                 text: 'Our aquaculture platform is an integrated end-to-end solution [from farm to fork], powered by cloud computing and artificial intelligence, to accelerate the transition to a sustainable blue economy. Our goal is to bring market transparency so that fish farmers can value their products and increase their competitiveness. Discover our offers: ',
                                 imageUrl: 'static/images/headers/bludocc_logo.png',
                                 link: 'bludocc',
                                 class: 'large-size',
                                 linkout: 'https://bludocc.com', 
                            },
                            
                        ],
                    },
                    callToAction: {
                        title: {
                            before: 'Empower',
                            after: 'your business'
                        },
                        class: 'bg-gray',
                        button: {
                            text: 'Contact us',
                            link: '/contato'
                        }
                    },
                    current: 0,
                    partners: [
                        {
                            imageUrl: 'static/images/partners/BGI.png',
                            link: ''
                        },
                        {
                            imageUrl: 'static/images/partners/ADSA.png',
                            link: ''
                        },
                        {
                            imageUrl: 'static/images/partners/Astro.png',
                            link: ''
                        },
                        {
                            imageUrl: 'static/images/partners/Intereg.png',
                            link: ''
                        },
                        {
                            imageUrl: 'static/images/partners/IPN.png',
                            link: ''
                        },
                        {
                            imageUrl: 'static/images/partners/USG.png',
                            link: ''
                        },
                        {
                            imageUrl: 'static/images/partners/Viitra.png',
                            link: ''
                        },
                        {
                            imageUrl: 'static/images/partners/Cin.png',
                            link: ''
                        },
                        
                    ],
                    contact: {
                        title: 'Talk to us!',
                        description: 'We want to hear you! Count on us to take the next step to improve your business. Fill up the form with your information and someone from our team will be in touch to better identify your needs.',
                        msgForm: undefined
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue